// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"fa66e","row":"c4c0e","content":"_4f09f"};